import type { NavSection } from './types';

export const navigation: NavSection[] = [
  {
    id: 'products',
    title: 'Products',
    children: [
      { id: 'pro', title: 'Product List', path: '/products/pro' },
      { id: 'cat', title: 'Categories', path: '/products/cat' },
      { id: 'pst', title: 'Statuses', path: '/products/pst' },
      { id: 'dwn', title: 'Downloads', path: '/products/dwn' },
    ],
  },
  {
    id: 'orders',
    title: 'Orders',
    children: [
      { id: 'ord', title: 'Order List', path: '/orders/ord' },
    ],
  },
  {
    id: 'setup',
    title: 'Setup',
    children: [
      { id: 'del', title: 'Delivery Methods', path: '/setup/del' },
      { id: 'cpr', title: 'Country Pricing', path: '/setup/cpr' },
      { id: 'ost', title: 'Order Statuses', path: '/setup/ost' },
    ],
  },
  {
    id: 'content',
    title: '4Each Content',
    children: [
      { id: 'ref', title: 'References', path: '/content/ref' },
      { id: 'par', title: 'Partners', path: '/content/par' },
      { id: 'tea', title: 'Team', path: '/content/tea' },
      { id: 'fea', title: 'Feature Cards', path: '/content/fea' },
    ],
  },
  {
    id: 'customers',
    title: 'Customers',
    children: [
      { id: 'cus', title: 'Customer List', path: '/customers/cus' },
      { id: 'cst', title: 'Statuses', path: '/customers/cst' },
      { id: 'cou', title: 'Countries', path: '/customers/cou' },
      { id: 'dlo', title: 'Download Log', path: '/customers/dlo' },
    ],
  },
  {
    id: 'cms',
    title: 'CMS Pages',
    children: [
      { id: 'pag', title: 'Page Manager', path: '/cms/pag' },
    ],
  },
  {
    id: 'admin',
    title: 'Administration',
    children: [
      { id: 'adm', title: 'Admin Users', path: '/admin/adm' },
    ],
  },
];

export function parseAllowedSections(allowedSections: string | null): Set<string> | null {
  if (!allowedSections) return null;
  const trimmed = allowedSections.trim();
  if (!trimmed) return null;
  return new Set(trimmed.split(',').map((s) => s.trim()).filter(Boolean));
}

export function isSectionAllowed(sectionId: string, allowed: Set<string> | null): boolean {
  if (!allowed) return true;
  if (allowed.has('*')) return true;
  if (allowed.has(sectionId)) return true;
  return false;
}

export function filterNavigation(nav: NavSection[], allowed: Set<string> | null): NavSection[] {
  if (!allowed) return nav;
  return nav
    .map((section) => ({
      ...section,
      children: section.children.filter((item) => isSectionAllowed(item.id, allowed)),
    }))
    .filter((section) => isSectionAllowed(section.id, allowed) || section.children.length > 0);
}
